// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSubCategoryQueryResult, selectSubCategorysPageLoading, selectSubCategorysShowInitWaitingMessage} from '../_selectors/sub-category.selectors';

export class SubCategorysDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSubCategorysPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSubCategorysShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSubCategoryQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
